import { cn } from '@utils'
import { ButtonSizeType, ButtonThemeType } from './button.types'

export enum ButtonTheme {
  DEFAULT = 'default',
  WHITE = 'white',
  BLACK = 'black',
}

export enum ButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export function getButtonThemeClass(
  theme?: ButtonThemeType,
  bold?: boolean,
  bgTransparent?: boolean
) {
  let result = bold ? 'font-bold ' : ''
  switch (theme) {
    case ButtonTheme.WHITE:
      result += cn('bg-white text-black hover:bg-primary-light', {
        'bg-transparent text-primary hover:bg-primary hover:text-white':
          bgTransparent,
      })
      break
    case ButtonTheme.BLACK:
      result += cn('bg-black text-white hover:bg-black/75', {
        'bg-transparent text-black hover:bg-transparent hover:text-primary hover:border-primary':
          bgTransparent,
      })
      break
    case ButtonTheme.DEFAULT:
    default:
      result += cn('bg-primary text-white hover:bg-primary-dark', {
        'bg-transparent hover:bg-white hover:border-white hover:text-font-primary':
          bgTransparent,
      })
      break
  }
  return result
}

export function getButtonSizeClass(size?: ButtonSizeType) {
  switch (size) {
    case ButtonSize.SMALL:
      return 'rounded-sm h-10 px-4 text-sm'
    case ButtonSize.LARGE:
      return 'rounded-lg h-15 px-6 text-lg'
    case ButtonSize.MEDIUM:
    default:
      return 'rounded h-12.5 px-5 text-base'
  }
}

export function getButtonOutlineClass(
  outline?: boolean,
  theme?: ButtonThemeType
) {
  if (!outline) return ''

  if (theme === ButtonTheme.WHITE) {
    return 'border border-primary'
  }

  if (theme === ButtonTheme.BLACK) {
    return 'border border-black'
  }

  if (theme === ButtonTheme.DEFAULT) {
    return 'border border-white'
  }

  return 'border border-current'
}
